import { Image, Layers, LayoutTemplate, Palette, Shapes, Sparkles, Type, Upload } from 'lucide-react';
import { cn } from '../../lib/utils';
import { FOCUS_RING } from './constants';

export const TOOL_TABS = [
  { id: 'text', label: 'Text', icon: Type },
  { id: 'designs', label: 'Ready text', icon: LayoutTemplate },
  { id: 'colors', label: 'Colors', icon: Palette },
  { id: 'ai', label: 'AI', icon: Sparkles },
  { id: 'elements', label: 'Elements', icon: Shapes },
  { id: 'uploads', label: 'Uploads', icon: Upload },
  { id: 'background', label: 'Background', icon: Image },
  { id: 'layers', label: 'Layers', icon: Layers },
];

// Glyphs live in the text tools (selected text box), not here. Uploads sit under Elements on a phone.
export const PHONE_TABS = TOOL_TABS.filter((t) => t.id !== 'uploads');

/** Desktop tool rail (advanced mode). */
export const ToolRail = ({ tab, onTab }) => (
  <nav aria-label="Tools" className="w-[84px] shrink-0 bg-paper border-r border-[#E6E1D6] px-2 py-3 flex flex-col gap-1">
    {TOOL_TABS.map(({ id, label, icon: Icon }) => {
      const on = tab === id;
      return (
        <button
          key={id}
          type="button"
          onClick={() => onTab(id)}
          aria-pressed={on}
          className={cn(
            'h-[66px] rounded-2xl flex flex-col gap-[5px] items-center justify-center text-[11px] font-bold border-[1.5px] border-transparent',
            on ? 'gradient-border-strong text-ink' : 'text-[#6B665C] hover:text-ink hover:bg-cream',
            FOCUS_RING
          )}
          data-testid={`tool-${id}`}
        >
          <Icon className={cn('h-[21px] w-[21px]', id === 'ai' && on && 'text-pink')} aria-hidden="true" />
          {label}
        </button>
      );
    })}
  </nav>
);

/** Phone bottom tab bar. */
export const PhoneTabBar = ({ tab, onTab }) => (
  <nav aria-label="Tools" className="h-16 shrink-0 grid grid-cols-7 border-t border-[#EEEBE4] bg-white px-1.5 pb-[env(safe-area-inset-bottom)]">
    {PHONE_TABS.map(({ id, label, icon: Icon }) => (
      <button
        key={id}
        type="button"
        onClick={() => onTab(id)}
        aria-pressed={tab === id}
        className={cn(
          'flex flex-col gap-1 items-center justify-center text-[10.5px] font-bold rounded-xl min-w-0',
          tab === id ? 'text-ink' : 'text-[#8C857A]',
          FOCUS_RING
        )}
        data-testid={`phone-tool-${id}`}
      >
        <Icon className="h-[19px] w-[19px]" aria-hidden="true" />
        <span className="leading-[1.05] text-center">{label}</span>
      </button>
    ))}
  </nav>
);

/** Quick-control chip in the phone bottom sheet. */
export const QuickChip = ({ label, glyph, active, onClick, glyphStyle, testId }) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={active}
    className={cn(
      'shrink-0 h-16 min-w-16 px-2 rounded-[14px] flex flex-col gap-1 items-center justify-center text-[11px] font-bold text-ink',
      active ? 'gradient-border-strong' : 'border border-[#E6E1D6] bg-white',
      FOCUS_RING
    )}
    data-testid={testId}
  >
    <span className="text-[17px] leading-none h-[18px] flex items-center" style={glyphStyle} aria-hidden="true">
      {glyph}
    </span>
    {label}
  </button>
);
